<template>
  <div class="row justify-content-end">
    <div class="col-auto px-3">
      <select
        class="form-select form-select-sm mb-3"
        v-model="action_type"
        @change="loadActivityLog()"
      >
        <option selected="" value="">{{ $t('select_action_log') }}</option>
        <option value="Login">Login</option>
        <option value="Create">Create</option>
        <option value="Send TB">Send TB</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <!-- Desktop table -->
      <div v-if="!isMobile" class="table-responsive">
        <table class="table table-striped table-hover table-sm">
          <thead>
            <tr>
              <th>{{ $t('action_time') }}</th>
              <th>{{ $t('action_type') }}</th>
              <th>{{ $t('user') }}</th>
              <th>{{ $t('action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" v-bind:key="log.id">
              <td>{{ getTimeFormatted(log.action_time) }}</td>
              <td>{{ log.action_type }}</td>
              <td>{{ log.actor_bez }}</td>
              <td>{{ log.remarks }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile: Apple-style list -->
      <div v-else class="ios-log-list">
        <div v-for="log in logs" :key="log.id" class="ios-log-row">
          <div class="ios-log-badge" :class="badgeClass(log.action_type)">
            {{ log.action_type.charAt(0) }}
          </div>
          <div class="ios-log-content">
            <div class="ios-log-header">
              <span class="ios-log-actor">{{ log.actor_bez }}</span>
              <span class="ios-log-time">{{ getTimeFormatted(log.action_time) }}</span>
            </div>
            <div class="ios-log-type">{{ log.action_type }}</div>
            <div class="ios-log-remarks">{{ log.remarks }}</div>
          </div>
        </div>
        <div v-if="logs.length === 0" class="ios-log-empty">Keine Einträge</div>
      </div>

      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-end">
          <li class="page-item" :class="{ disabled: !showPrevButton }">
            <a class="page-link" @click="loadPrev()">&laquo;</a>
          </li>
          <li class="page-item" :class="{ disabled: !showNextButton }">
            <a class="page-link" href="#" @click="loadNext()">&raquo;</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ActivityLogs',
  components: {},
  data() {
    return {
      logs: [],
      action_type: '',
      currentPage: 1,
      showNextButton: false,
      showPrevButton: false,
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.onResize);
    this.loadActivityLog();
  },
  updated() {},
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
    loadNext() {
      this.currentPage += 1;
      this.loadActivityLog();
    },
    loadPrev() {
      this.currentPage -= 1;
      this.loadActivityLog();
    },
    loadActivityLog() {
      axios
        .get(`/api/v1/log/?page=${this.currentPage}&action_type=${this.action_type}`)
        .then((response) => {
          this.showNextButton = response.data.next != null;
          this.showPrevButton = !!response.data.previous;
          this.logs = response.data.results;
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
    },
    getTimeFormatted(time) {
      return new Date(time).toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    badgeClass(type) {
      const map = {
        Login: 'ios-log-badge--login',
        Create: 'ios-log-badge--create',
        'Send TB': 'ios-log-badge--send',
      };
      return map[type] || 'ios-log-badge--default';
    },
  },
  computed: {},
};
</script>

<style scoped>
.ios-log-list {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0.5px rgba(0, 0, 0, 0.06);
  margin-bottom: 1rem;
}

.ios-log-row {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border-bottom: 0.5px solid rgba(60, 60, 67, 0.18);
  gap: 12px;
}

.ios-log-row:last-child {
  border-bottom: none;
}

.ios-log-badge {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: #fff;
  margin-top: 1px;
}

.ios-log-badge--login {
  background: #34c759;
}

.ios-log-badge--create {
  background: #007aff;
}

.ios-log-badge--send {
  background: #ff9500;
}

.ios-log-badge--default {
  background: #8e8e93;
}

.ios-log-content {
  flex: 1;
  min-width: 0;
}

.ios-log-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 2px;
}

.ios-log-actor {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1c1c1e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ios-log-time {
  font-size: 0.75rem;
  color: #8e8e93;
  flex-shrink: 0;
}

.ios-log-type {
  font-size: 0.8125rem;
  color: #8e8e93;
  margin-bottom: 3px;
}

.ios-log-remarks {
  font-size: 0.875rem;
  color: #3c3c43;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ios-log-empty {
  padding: 24px 16px;
  text-align: center;
  color: #8e8e93;
  font-size: 0.9375rem;
}
</style>
